import React, { ReactElement } from 'react';
import Switch from 'react-switch';

interface OptSwitchProps {
  optedIn: boolean;
  onClick: () => void;
  screenReaderPhrase: string | Array<string | ReactElement<any>>;
}

const OptSwitch = ({
  optedIn,
  onClick,
  screenReaderPhrase,
}: OptSwitchProps) => {
  const labelString = Array.isArray(screenReaderPhrase)
    ? screenReaderPhrase.join('')
    : String(screenReaderPhrase);
  return (
    <Switch
      checked={optedIn}
      onChange={onClick}
      aria-label={labelString}
      data-testid={'react-switch'}
    />
  );
};

export default OptSwitch;
